export default __webpack_public_path__ + "static/media/mainImage.446ec735.jpg";